<template>
  <article>
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      Авторы
    </h1>
    <CommonComplexFiltering
      :key="isAnyFiltersActive"
      class="mb-[20px]"
      :sort-options="sortOptions"
      :filters-active="filters"
      is-centuries-disabled
    />
    <div class="grid grid-cols-1 gap-[20px]">
      <CommonAuthorInfo
        v-for="author in authors?.data?.value"
        :key="author.id"
        class="col-span-1"
        :author="author"
      />
    </div>
    <div class="mt-[64px] flex justify-center">
      <BaseTheButtonNew
        v-if="authors.hasNextPage.value"
        text="Показать еще"
        @click="authors.fetchNextPage()"
      />
    </div>
  </article>
</template>

<script setup>
const route = useRoute();
const router = useRouter();

const filters = computed(() => {
  return {
    sort_by: route.query?.sort_by,
  };
});

const { authors, resetPage } = useAuthors({ filters, per_page: 9 });

watch(filters, (newValue, prevValue) => {
  if (JSON.stringify(newValue) === JSON.stringify(prevValue)) return;
  router.push({ query: { ...route.query, page: undefined } });
  resetPage(prevValue);
});

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const sortOptions = [
  { id: 0, label: 'По алфавиту', value: '', icon: 'random' },
  {
    id: 1,
    label: 'По количеству публикаций',
    value: 'count',
    icon: 'chat-circle',
  },
];

useHead({
  head: {
    title: 'Наши авторы | Федеральный портал Истории России',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'Авторы Федерального портала Истории России. Российское военно-историческое общество. Мы знаем правду.',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: `${useHostApp()}${route.path}`,
      },
    ],
  },
});
</script>

<style lang="scss"></style>
